import { render, staticRenderFns } from "./orderThumb.vue?vue&type=template&id=3f0cb47e&scoped=true"
import script from "./orderThumb.vue?vue&type=script&lang=js"
export * from "./orderThumb.vue?vue&type=script&lang=js"
import style0 from "./orderThumb.vue?vue&type=style&index=0&id=3f0cb47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0cb47e",
  null
  
)

export default component.exports